import React from 'react'
import PropTypes from 'prop-types'
import { TtIcon } from '@23/react'
import { intl } from 'lang/intl'
import { TooltipComponent } from '../../../../components'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'
import usePollsOverlays from '../../../../../Webinar/hooks/usePollsOverlay'

import './PollOverlayTrigger.scss'

const PollOverlayTrigger = (props) => {
  const { poll } = props
  const { togglePollOverlay, overlayPollId } = usePollsOverlays()
  const { accent } = useWebinarColors()

  const isActive = overlayPollId === poll.poll_id

  return (
    <TooltipComponent
      title={
        isActive
          ? intl.formatMessage({ defaultMessage: 'Remove from the video' })
          : intl.formatMessage({ defaultMessage: 'Display on the video' })
      }
      placement="topRight"
    >
      <button
        aria-label={`${isActive ? 'hide' : 'show'} poll overlay`}
        type="button"
        className="poll-overlay-trigger"
        onClick={() => togglePollOverlay(poll)}
      >
        <TtIcon
          name="eye"
          style={{ color: isActive ? accent.color : 'inherit' }}
        />
      </button>
    </TooltipComponent>
  )
}

PollOverlayTrigger.defaultProps = {}

PollOverlayTrigger.propTypes = {
  poll: PropTypes.object,
}

export default PollOverlayTrigger
